// client/requestHandlers/unpack.ts
import { ignoreSymbol } from "@adornis/base/logging.js";
import { catchError, map } from "rxjs/operators";
import { combineErrors } from "../../utils/helpers.js";
var UnpackHandler = class {
  constructor(upstream) {
    this.upstream = upstream;
    this.destroyed = false;
  }
  subscription(op, payload) {
    return this.upstream.subscription(op, payload).pipe(
      map((packed) => this.unpack(op, packed)),
      catchError((packed) => {
        throw this.unpackError(op, packed);
      })
    );
  }
  async query(op, payload) {
    return this.upstream.query(op, payload).then((packed) => this.unpack(op, packed)).catch((packed) => {
      throw this.unpackError(op, packed);
    });
  }
  async mutation(op, payload) {
    return this.upstream.mutation(op, payload).then((packed) => this.unpack(op, packed)).catch((packed) => {
      throw this.unpackError(op, packed);
    });
  }
  stop(payload) {
    this.upstream.stop(payload);
  }
  destroy() {
    if (this.destroyed)
      throw new Error("Destroying already destroyed UnpackHandler!");
    this.destroyed = true;
    this.upstream.destroy();
  }
  unpackError(op, errors) {
    if (Array.isArray(errors)) {
      const combinedError = combineErrors(errors);
      console.error(
        `%c\u{1F32A}\uFE0F error from the server`,
        "color: white; font-size: 1.6em; font-weight: bold; text-shadow: 1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000, -1px -1px 0 #000, 0px 1px 0 #000, 0px -1px 0 #000, -1px 0px 0 #000, 1px 0px 0 #000, 2px 2px 0 #000, -2px 2px 0 #000, 2px -2px 0 #000, -2px -2px 0 #000, 0px 2px 0 #000, 0px -2px 0 #000, -2px 0px 0 #000, 2px 0px 0 #000, 1px 2px 0 #000, -1px 2px 0 #000, 1px -2px 0 #000, -1px -2px 0 #000, 2px 1px 0 #000, -2px 1px 0 #000, 2px -1px 0 #000, -2px -1px 0 #000;",
        `
${combinedError}`
      );
      combinedError[ignoreSymbol] = true;
      return combinedError;
    }
    console.error(
      `%c\u{1F32A}\uFE0F BaseQL Transport error`,
      "color: white; font-size: 1.6em; font-weight: bold; text-shadow: 1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000, -1px -1px 0 #000, 0px 1px 0 #000, 0px -1px 0 #000, -1px 0px 0 #000, 1px 0px 0 #000, 2px 2px 0 #000, -2px 2px 0 #000, 2px -2px 0 #000, -2px -2px 0 #000, 0px 2px 0 #000, 0px -2px 0 #000, -2px 0px 0 #000, 2px 0px 0 #000, 1px 2px 0 #000, -1px 2px 0 #000, 1px -2px 0 #000, -1px -2px 0 #000, 2px 1px 0 #000, -2px 1px 0 #000, 2px -1px 0 #000, -2px -1px 0 #000;",
      `
${errors}`
    );
    errors[ignoreSymbol] = true;
    return errors;
  }
  unpack(op, packed) {
    if (!packed)
      return op.arrayDepth() ? [] : null;
    if (packed.data && Object.hasOwnProperty.call(packed.data, op.name)) {
      return packed.data[op.name];
    }
  }
};
export {
  UnpackHandler
};
